import { getWebview } from '@cian/webview/webview';
import { useSelector } from 'react-redux';

import { selectIsWebview } from '../selectors/selectIsWebview';

export const useWebViewRedirect = () => {
  const isWebview = useSelector(selectIsWebview);
  const webview = isWebview ? getWebview() : null;

  const redirect = (url: string) => {
    if (webview) {
      webview.sendAction({
        action: 'open-deeplink',
        payload: {
          url,
        },
      });
    }
  };

  return { redirect };
};
